module.exports = __webpack_public_path__ + "img/ic_cross.09b04ca8.svg";